<template>
  <component
    :is="currentComponent"
    v-bind="currentQuestion ? currentQuestion.data : null"
    :expectedResponse="currentQuestion ? currentQuestion.expectedResponse : null"
    :explanation="currentQuestion ? currentQuestion.explanation : null"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import userMixin from '@/mixins/user'

export default {
  name: 'QuizStep',
  mixins: [userMixin],
  computed: {
    ...mapGetters({
      currentQuestion: 'currentQuestion',
      currentComponent: 'questionComponent'
    })
  }
}
</script>
